// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fmhbl","row":"styles_row__gL4Dv","head":"styles_head__D_0u9","column":"styles_column__ksoTO"};